import { api } from "../http";
import type { ReferenceRecord } from "../../../components/reference/types";
import { buildReferenceCacheKey, isNavigatorOffline, searchCachedReferences } from "../../offline/referenceCache";

export type HumanRemainsReferenceType = "document-types";

function buildQuery(params: Record<string, unknown>) {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&");
}

const prefixFor = (type: HumanRemainsReferenceType) => buildReferenceCacheKey("human-remains", type);

function path(type: HumanRemainsReferenceType) {
  return `/api/human-remains/references/${type}`;
}

export const humanRemainsReferencesApi = {
  async search(type: HumanRemainsReferenceType, params: { q?: string; limit?: number } = {}) {
    if (isNavigatorOffline()) {
      const cached = await searchCachedReferences(prefixFor(type), params);
      if (cached) return cached;
    }
    try {
      const query = buildQuery(params);
      return await api.get<ReferenceRecord[]>(`${path(type)}${query ? `?${query}` : ""}`);
    } catch (error) {
      const cached = await searchCachedReferences(prefixFor(type), params);
      if (cached) return cached;
      throw error;
    }
  },
  async create(type: HumanRemainsReferenceType, payload: Record<string, string | undefined>) {
    return api.post<ReferenceRecord, Record<string, string | undefined>>(path(type), payload);
  },
  async update(type: HumanRemainsReferenceType, id: string, payload: Record<string, string | undefined>) {
    return api.put<ReferenceRecord, Record<string, string | undefined>>(
      `${path(type)}/${encodeURIComponent(id)}`,
      payload,
    );
  },
};

export default humanRemainsReferencesApi;
